module.exports = __webpack_public_path__ + "static/media/marketing-1-checked.39c9bc5d.png";